import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import(/* webpackChunkName: "products" */ '../views/Products.vue')
  },
  {
    path: '/wishlist',
    name: 'Wishlist',
    component: () => import(/* webpackChunkName: "wishlist" */ '../views/Wishlist.vue')
  },
  {
    path: '/merchants',
    name: 'merchants',
    component: () => import(/* webpackChunkName: "wishlist" */ '../views/Merchants.vue')
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import(/* webpackChunkName: "checkout" */ '../views/Checkout.vue')
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "account" */ '../views/Account.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import(/* webpackChunkName: "signup" */ '../views/Signup.vue')
  },
  {
   path: '/*',
   name: 'NotFound',
   component: () => import(/* webpackChunkName: "NotFound" */ '../views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  let isAuthenticated = window.localStorage.getItem('care_user_auth_token') || null;
  if(isAuthenticated && (to.name === 'Login' || to.name === 'Signup')){
    next({name: 'Home'})
  } else if (!isAuthenticated && (to.name === 'Login'|| to.name === 'Signup' || to.name === 'Products' || to.name === 'Home')) {
    next()
  } else if(!isAuthenticated){
    next({name: 'Login'})
  } else {
    next();
  }
})
export default router
